import React from "react";
export const RiverFormContext = React.createContext(null);
